export default (props, e) => {
  e.preventDefault();
	window.scrollTo(0, 0);

	/*const target = (document.querySelector("html"));
	if (target) {
		e.preventDefault();
		target.scrollIntoView({
			behavior: 'smooth',
			block: "start"
		});
	}*/
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/toTop.js